export const GLOBAL_STATE = 'CCLSModule'

export const CCLS_MODULE = 'CCLSModule'
export const CCLS_MODULE_LIST = 'CCLSModuleList'
export const CCLS_MODULE_ALL = 'CCLSModuleAll'
export const CCLS_MODULE_CREATE = 'CCLSModuleCreate'
export const CCLS_MODULES_FILTER = 'CCLSModulesFilter'
